<template>
  <div class="section-observations h-100">
    <div class="h-100 d-flex flex-column justify-content-between">
      <div class="d-flex flex-column flex-grow-1">
        <b-row class="d-flex align-items-center mb-2 mt-1">
          <b-col>
            <span class="ap-title ap-title__main">{{ $t('diagnosis.sections.observations') }}</span>
          </b-col>
          <b-col
            cols="auto"
            class="d-flex justify-content-end"
          >
            <b-button
              v-if="$_canEditCase()"
              v-tooltip="$t('global.description.clear')"
              :disabled="disabled"
              class="btn__icon btn__icon--primary  px-2"
              @click="cleanCaseObservationText"
            >
              <i
                class="far fa-eraser"
                aria-hidden="true"
              />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="diagnosis-layout-height flex-grow-1">
          <b-col>
            <b-form-textarea
              ref="caseObservationsTextArea"
              v-model="caseObservation"
              class="w-100 observations-textarea"
              :disabled="!$_canEditCase() || disabled"
              no-resize
            />
          </b-col>
        </b-row>
      </div>
      <div class="d-flex justify-content-end">
        <vt-loading-button
          v-if="$_canEditCase()"
          :disabled="disabled"
          class="btn__outline btn-sm mt-2"
          qa="case-observations-save-button"
          :params="{ promise: save, shortkeys: ['alt', 's'] }"
        >
          <i
            class="fal fa-save mr-2"
            aria-hidden="true"
          />
          {{ $t('global.save') }}
        </vt-loading-button>
      </div>
    </div>
  </div>
</template>

<script>
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'
import { cloneDeep, isEqual } from 'lodash'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
export default {
    name: 'CaseObservations',
    mixins: [
        CaseOperationGuardMixin
    ],
    props: {
        labId: { type: Number, required: true },
        casId: { type: Number, required: true },
        disabled: { type: Boolean, default: false }
    },
    data() {
        return {
            caseStudy: null,
            caseObservation: null,
            originalCaseObservation: null
        }
    },
    async mounted() {
        await this.loadCaseAndObservations()
        const caseObservationTextLength = this.caseObservation?.length
        this.$_moveInputElementCaretToEnd(this.$refs.caseObservationsTextArea, caseObservationTextLength)
    },
    methods: {
        hasBeenChanged() {
            return !isEqual(this.originalCaseObservation, this.caseObservation)
        },
        async loadCaseAndObservations() {
            const successfulLoad = await this.loadCase()
            if (successfulLoad) {
                this.caseObservation = this.caseStudy.comprehensiveDiagnosisObservations
                this.originalCaseObservation = cloneDeep(this.caseObservation)
                this.$emit('reloadSummary')
            }
        },
        async loadCase() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(diagnosisCaseService.getDiagnosisCaseByCaseId(this.labId, this.casId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return false
            }
            this.caseStudy = response
            return true
        },
        async save() {
            const data = {
                comprehensiveDiagnosisObservations: this.caseObservation,
                originalConcurrencyUpdatedAt: this.caseStudy.originalConcurrencyUpdatedAt

            }
            this.updateLoading(true)
            const [err, response] = await this.toCall(diagnosisCaseService.updateCase(this.labId, this.caseStudy.casId, data))
            this.updateLoading(false)
            if (err) {
                if (err.response && err.response.data && err.response.data.code === this.$apiExceptions.CONCURRENCY_ERROR) {
                    return this.processBasicConcurrencyConflict(this.$tc('global.case', 1), err, () => {
                        this.caseStudy.originalConcurrencyUpdatedAt = err.response.data.currentConcurrencyUpdatedAt
                        return this.save(data)
                    })
                } else {
                    this.showErrorModalGlobal()
                    return
                }
            }
            this.caseObservation = response.comprehensiveDiagnosisObservations
            this.originalCaseObservation = cloneDeep(response.comprehensiveDiagnosisObservations)
            this.$emit('updateCase')
            this.showToastSuccessGlobal()
            await this.loadCaseAndObservations()
            return true
        },
        cleanCaseObservationText() {
            this.caseObservation = ''
        }
    }
}
</script>

<style lang="scss">
.section-observations .ql-toolbar.ql-snow {
  padding: 2px;
}

.section-observations .ql-editor {
  height: calc(100vh - 365px);
  transition: 0.35s;
  overflow-y: auto;
}

/*--Styles for large screen--*/
@media (max-width: 1300px) {
  .section-observations .ql-editor {
  height: calc(100vh - 380px);
}
}

</style>
